/**
 * @see https://umijs.org/docs/max/access#access
 * */
import { checkButtonPermission, checkMenuPermission } from '@/utils/permission';

export default function access(
  initialState: { currentUser?: API.SwimStaffDetailVo } | undefined,
) {
  const { currentUser } = initialState ?? {};

  // 基础权限检查
  const isLoggedIn = !!currentUser;

  return {
    // 基础权限
    canAdmin: currentUser && currentUser.access === 'admin',
    isLoggedIn,

    // 角色权限检查函数
    hasRole: (roleId: number) => {
      return currentUser?.roleId === roleId;
    },

    /**
     * 菜单权限检查函数
     * @param menuCode 菜单编码
     * @returns 是否有该菜单权限
     */
    hasMenuAccess: (menuCode: string) => {
      if (!isLoggedIn) return false;
      return checkMenuPermission(menuCode);
    },

    /**
     * 按钮权限检查函数
     * @param menuCode 菜单编码
     * @param buttonCode 按钮编码
     * @returns 是否有该按钮权限
     */
    hasButtonAccess: (menuCode: string, buttonCode: string) => {
      if (!isLoggedIn) return false;
      return checkButtonPermission(menuCode, buttonCode);
    },

    /**
     * 通用权限检查函数（向后兼容）
     * 优先检查菜单权限，如果传入了按钮编码则检查按钮权限
     */
    canAccess: (permissionCode: string, buttonCode?: string) => {
      if (!isLoggedIn) return false;

      if (buttonCode) {
        // 如果提供了按钮编码，检查按钮权限
        return checkButtonPermission(permissionCode, buttonCode);
      }

      // 否则检查菜单权限
      return checkMenuPermission(permissionCode);
    },
  };
}
